const formatAnswer = (projectId, question, answer) => {
  if (question.type === 'radio') {
    return {
      projectId,
      sectionId: question.sectionId,
      questionId: question.id,
      type: 'radio',
      value: question.options.find((option) => option.id === answer).value,
      optionId: answer,
    };
  }
  if (question.type === 'multiselect') {
    return answer.map((optionId) => ({
      projectId,
      sectionId: question.sectionId,
      questionId: question.id,
      type: 'multiselect',
      value: question.options.find((option) => option.id === optionId).value,
      optionId,
    }));
  }
  if (question.type === 'percent') {
    return {
      projectId,
      sectionId: question.sectionId,
      questionId: question.id,
      type: 'percent',
      value: answer,
    };
  }
  return null;
};

export default formatAnswer;
